/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/prop-types */
import React from "react";

export const SplitscreenViewIcon = (props) => {
  const { color, width = "13", height = "16" } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 13 16'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M11.2 1.6v4H1.6v-4h9.6m0-1.6H1.6C.72 0 0 .72 0 1.6v4c0 .88.72 1.6 1.6 1.6h9.6c.88 0 1.6-.72 1.6-1.6v-4c0-.88-.72-1.6-1.6-1.6zm0 10.4v4H1.6v-4h9.6m0-1.6H1.6c-.88 0-1.6.72-1.6 1.6v4c0 .88.72 1.6 1.6 1.6h9.6c.88 0 1.6-.72 1.6-1.6v-4c0-.88-.72-1.6-1.6-1.6z'
        fill={color}
        fillRule='nonzero'
      />
    </svg>
  );
};
export const DownloadIcon = (props) => {
  const { color, size = 17, viewBox = "0 0 17 17" } = props;
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox={viewBox}
    >
      <g fill='none' fillRule='evenodd'>
        <g
          stroke={color || "#183238"}
          strokeLinecap='square'
          strokeLinejoin='round'
          strokeWidth='1.333'
        >
          <path
            d='M10.605 8.778v2.37c0 .655-.528 1.185-1.179 1.185H1.178c-.65 0-1.178-.53-1.178-1.185v-2.37'
            transform='translate(.587 .667) translate(2.651 1)'
          />
          <g>
            <path
              d='M5.891 2.963L2.946 0 0 2.963'
              transform='translate(.587 .667) translate(2.651 1) matrix(1 0 0 -1 2.357 9.667)'
            />
            <path
              d='M2.946 1.185L2.946 8.296'
              transform='translate(.587 .667) translate(2.651 1) matrix(1 0 0 -1 2.357 9.667)'
            />
          </g>
        </g>
        <path d='M0 0H15.907V16H0z' transform='translate(.587 .667)' />
      </g>
    </svg>
  );
};

export const ZoomOutIcon = (props) => {
  const { size = "16" } = props;
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 16 16'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='m15.022 16-5.844-5.844a4.897 4.897 0 0 1-1.556.9 5.5 5.5 0 0 1-1.889.322c-1.6 0-2.955-.556-4.066-1.667C.556 8.6 0 7.26 0 5.69c0-1.57.556-2.911 1.667-4.022C2.777.556 4.126 0 5.71 0c1.57 0 2.908.556 4.011 1.667 1.104 1.11 1.656 2.452 1.656 4.022 0 .637-.104 1.252-.311 1.844a5.64 5.64 0 0 1-.934 1.667L16 15.022l-.978.978zm-9.31-5.956c1.2 0 2.221-.425 3.066-1.277.844-.852 1.266-1.878 1.266-3.078S9.622 3.463 8.778 2.61C7.933 1.76 6.91 1.333 5.71 1.333c-1.215 0-2.248.426-3.1 1.278-.852.852-1.278 1.878-1.278 3.078s.426 2.226 1.278 3.078c.852.852 1.885 1.277 3.1 1.277zm-2.268-3.71V5h4.467v1.333H3.444z'
        fill='#32325D'
        fillRule='nonzero'
      />
    </svg>
  );
};

export const ZoomInIcon = (props) => {
  const { size = "16" } = props;
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 16 16'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='m15.022 16-5.844-5.844a4.897 4.897 0 0 1-1.556.9 5.5 5.5 0 0 1-1.889.322c-1.6 0-2.955-.556-4.066-1.667C.556 8.6 0 7.26 0 5.69c0-1.57.556-2.911 1.667-4.022C2.777.556 4.126 0 5.71 0c1.57 0 2.908.556 4.011 1.667 1.104 1.11 1.656 2.452 1.656 4.022 0 .637-.104 1.252-.311 1.844a5.64 5.64 0 0 1-.934 1.667L16 15.022l-.978.978zm-9.31-5.956c1.2 0 2.221-.425 3.066-1.277.844-.852 1.266-1.878 1.266-3.078S9.622 3.463 8.778 2.61C7.933 1.76 6.91 1.333 5.71 1.333c-1.215 0-2.248.426-3.1 1.278-.852.852-1.278 1.878-1.278 3.078s.426 2.226 1.278 3.078c.852.852 1.885 1.277 3.1 1.277zm.644-1.888H5.022V6.333H3.2V5h1.822V3.2h1.334V5h1.8v1.333h-1.8v1.823z'
        fill='#32325D'
        fillRule='nonzero'
      />
    </svg>
  );
};

export const FirstPageIcon = (props) => {
  const { size = "16" } = props;
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 20 16'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g fill='#32325D' fillRule='nonzero'>
        <path d='M8 16 0 8l8-8 1.427 1.427L2.855 8l6.572 6.573zM18 16l-8-8 8-8 1.427 1.427L12.855 8l6.572 6.573z' />
      </g>
    </svg>
  );
};

export const PrevPageIcon = (props) => {
  const { size = "16" } = props;
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 20 16'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g fill='#32325D' fillRule='nonzero'>
        <path
          d='M8 16 0 8l8-8 1.427 1.427L2.855 8l6.572 6.573z'
          fill='#32325D'
          fillRule='nonzero'
        />
      </g>
    </svg>
  );
};

export const NextPageIcon = (props) => {
  const { size = "16" } = props;
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 20 16'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='m1.427 16 8-8-8-8L0 1.427 6.573 8 0 14.573z'
        fill='#32325D'
        fillRule='nonzero'
      />
    </svg>
  );
};

export const LastPageIcon = (props) => {
  const { size = "16" } = props;
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 20 16'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g fill='#32325D' fillRule='nonzero'>
        <path d='m1.427 16 8-8-8-8L0 1.427 6.573 8 0 14.573zM11.427 16l8-8-8-8L10 1.427 16.573 8 10 14.573z' />
      </g>
    </svg>
  );
};

export const RotateClockwiseIcon = (props) => {
  const { size = "16", viewBox = "0 0 16 16" } = props;
  return (
    <svg
      width={size}
      height={size}
      viewBox={viewBox}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M6.857 16c-1.892 0-3.508-.67-4.847-2.01C.67 12.65 0 11.035 0 9.143c0-.94.181-1.829.543-2.667a7.093 7.093 0 0 1 3.676-3.714 6.49 6.49 0 0 1 2.657-.552h.59L6.058.8l.8-.8 2.781 2.781-2.78 2.78-.8-.8 1.409-1.409h-.59c-1.563 0-2.909.572-4.039 1.715-1.13 1.143-1.695 2.501-1.695 4.076 0 1.562.562 2.905 1.686 4.028 1.123 1.124 2.466 1.686 4.028 1.686.597 0 1.156-.086 1.676-.257a6.262 6.262 0 0 0 1.543-.771l.857.857a7.932 7.932 0 0 1-1.952.98A6.673 6.673 0 0 1 6.857 16zm4.648-2.362L7.01 9.143l4.495-4.495L16 9.143l-4.495 4.495zm0-1.619 2.876-2.876-2.876-2.876-2.876 2.876 2.876 2.876z'
        fill='#32325D'
        fillRule='nonzero'
      />
    </svg>
  );
};

export const RefreshIcon = (props) => {
  const { color = "#FFF", width = "16", height = "16" } = props;
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 16 16'
    >
      <g fill='none' fillRule='evenodd'>
        <g>
          <g>
            <path
              d='M0 0L16 0 16 16 0 16z'
              transform='translate(-389.000000, -106.000000) translate(389.000000, 106.000000)'
            />
            <path
              fill={color}
              fillRule='nonzero'
              d='M8 4v2l2.667-2.667L8 .667v2C5.053 2.667 2.667 5.053 2.667 8c0 1.047.306 2.02.826 2.84l.974-.973C4.167 9.313 4 8.673 4 8c0-2.207 1.793-4 4-4zm4.507 1.16l-.974.973C11.827 6.693 12 7.327 12 8c0 2.207-1.793 4-4 4v-2l-2.667 2.667L8 15.333v-2c2.947 0 5.333-2.386 5.333-5.333 0-1.047-.306-2.02-.826-2.84z'
              transform='translate(-389.000000, -106.000000) translate(389.000000, 106.000000)'
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const RedirectIcon = (props) => {
  const { color = "#FFF", width = "16", height = "16" } = props;
  return (
    <svg width={width} height={height} viewBox='0 0 16 16'>
      <g fill='none' fillRule='evenodd'>
        <g>
          <g>
            <g>
              <g fillRule='nonzero'>
                <g fill={color}>
                  <path
                    d='M12.667 12.667H3.333V3.333H8V2H3.333C2.597 2 2 2.597 2 3.333v9.334C2 13.403 2.597 14 3.333 14h9.334C13.4 14 14 13.4 14 12.667V8h-1.333v4.667zM9.333 2v1.333h2.394L5.173 9.887l.94.94 6.554-6.554v2.394H14V2H9.333z'
                    transform='translate(-1015 -1151) translate(935 1146) translate(80 5)'
                  />
                </g>
                <path
                  d='M0 0H16V16H0z'
                  transform='translate(-1015 -1151) translate(935 1146) translate(80 5)'
                />
              </g>
              <path
                d='M0 0H16V16H0z'
                transform='translate(-1015 -1151) translate(935 1146) translate(80 5)'
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
